import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import commonNo from 'locales/no.json';
import challengeNo from 'apps/Challenge/locales/no.json';
import eventsNo from 'apps/Events/locales/no.json';
import playerNo from 'components/Player/locales/no.json';
import adminPanelNo from 'apps/AdminPanel/locales/no.json';
import academyNo from 'apps/Academy/locales/no.json';
import composerNo from 'apps/Composer/locales/no.json';
import resourcesNo from 'apps/Resources/locales/no.json';

import commonEn from 'locales/en.json';
import challengeEn from 'apps/Challenge/locales/en.json';
import eventsEn from 'apps/Events/locales/en.json';
import playerEn from 'components/Player/locales/en.json';
import adminPanelEn from 'apps/AdminPanel/locales/en.json';
import academyEn from 'apps/Academy/locales/en.json';
import composerEn from 'apps/Composer/locales/en.json';
import resourcesEn from 'apps/Resources/locales/en.json';

// Used in the language switch in footer
const languages = [
  { name: 'Norsk', code: 'nb-NO' },
  { name: 'English', code: 'en-US' },
];

const resources = {
  'nb-NO': {
    common: commonNo,
    challenge: challengeNo,
    events: eventsNo,
    player: playerNo,
    adminPanel: adminPanelNo,
    academy: academyNo,
    composer: composerNo,
    resources: resourcesNo,
  },
  'en-US': {
    common: commonEn,
    challenge: challengeEn,
    events: eventsEn,
    player: playerEn,
    adminPanel: adminPanelEn,
    academy: academyEn,
    composer: composerEn,
    resources: resourcesEn,
  },
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    fallbackLng: 'nb-NO',
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
    react: {
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p', 'u'],
    },
  });

export default i18n;
export { languages };
